import '../../Div/index.js';
import { jsx } from 'react/jsx-runtime';
import { Div } from '../../Div/Div.js';
const List = ({
  as,
  css,
  color
}) => {
  const listStyleType = as === 'ol' ? {
    listStyleType: 'decimal'
  } : {
    listStyleType: 'disc'
  };
  return function list(node, children) {
    return /*#__PURE__*/jsx(Div, {
      as: as,
      display: "block",
      spacingStart: 3,
      css: css || listStyleType,
      color: color,
      children: children
    });
  };
};
export { List };
//# sourceMappingURL=List.js.map
